import React from 'react'
import Button from '../../../common/components/Button';

import { axiosPost } from '../../../common/js/axios-utility';
import { CrumplePopSignupContext } from '../../contexts/CrumplePopSignupContext';
import { errorToast } from '../../../common/js/toast-utility';

export default function CrumplePopEmailSignin({email, onComplete}) {
  const form = React.useRef(null);
  const [migrationState, setMigrationState] = React.useContext(CrumplePopSignupContext);

  const handleSubmit = async event => {
      event.preventDefault();
      setMigrationState({...migrationState, processing: true});
      const password = form.current.password.value;
      const {data} = await axiosPost('/cpop/signin', {email, password});
      try{
        if (data.success){
          const custData = data.data;
          const cpop_login = {token: custData.token, key: custData.public_key};
          Cookies.set('cpop_login', JSON.stringify(cpop_login))
          onComplete(custData);
        }
        else{
          throw new Error('Incorrect Password');
        }
      }
      catch(err){
        console.error(err);
        errorToast('Incorrect password entered. Please try again.');
        setMigrationState({...migrationState, processing: false});
      }
  }

  const handleBack = () => {
    setMigrationState({...migrationState, loginPage: 'select'});
  }

  return (
    <div className='cpop-email-signin'>
        <form ref={form} onSubmit={handleSubmit}>
          <div className='read-only-field cpop-signin-email-field'>
              <label>Email</label>
              <span>{email}</span>
          </div>
          <div className='form-row'>
              <div className='form-field'>
                  <label>CrumplePop password</label>
                  <input name="password" type="password" autoComplete='password' />
              </div>
          </div>
          <div className='cpop-signup-buttons text-right'>
                <Button 
                    className='btn-new back-btn' 
                    label="Back"
                    processingLabel="Back"
                    processing={migrationState.processing}
                    onClick={handleBack} />
                <Button 
                    className='btn-new' 
                    label="Sign In" 
                    processingLabel="Please Wait..."
                    processing={migrationState.processing}
                    submit />
            </div>
        </form>
    </div>
  )
}
